import { Close } from '@mui/icons-material'
import { DialogTitle, IconButton, Stack } from '@mui/material'
import { FC, PropsWithChildren, ReactNode, useContext } from 'react'

import Context from './Context'

interface ModalHeaderProps {
  icon?: ReactNode
  showCloseButton?: boolean
}

const ModalHeader: FC<PropsWithChildren<ModalHeaderProps>> = ({
  children,
  icon,
  showCloseButton,
}) => {
  const { onClose } = useContext(Context)

  return (
    <DialogTitle sx={{ p: 2, position: 'relative', bgcolor: 'white', typography: 'h6' }}>
      <Stack direction="row" spacing={1} sx={{ alignItems: 'center', lineHeight: 'normal' }}>
        <Stack alignItems="center" direction="row" gap={1}>
          {icon}
          {children}
        </Stack>

        {showCloseButton && (
          <IconButton size="small" sx={{ ml: 'auto !important' }} onClick={() => onClose()}>
            <Close fontSize="small" />
          </IconButton>
        )}
      </Stack>
    </DialogTitle>
  )
}

export default ModalHeader
